import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga'

import moment from 'moment';
import RelevanceCard from './comment-toggle/RelevanceCard';
import SarcasmTogglingCard from './comment-toggle/SarcasmTogglingCard';
import { 
  NO_SPECIFIC_EMOTION_PILL_CLASS,
  NO_SPECIFIC_EMOTION ,
  SARCASTIC_PILL_CLASS,
  NOT_SARCASTIC_PILL_CLASS,
  SARCASTIC_LABEL,
  NOT_SARCASTIC_LABEL,
  SARCASM_CONFIDENCE_SCORE_HOVER_TEXT,
  SARCASM_MANUALLY_TOGGLED_HOVER_TEXT,
  MARKED_AS_IRRELEVANT_LABEL,
  MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB,
  DATETIME_FORMAT_FOR_CARD_DISPLAY,
  E_PLUS_TWO,
  E_MINUS_TWO
} from '../redux/constants';
import { IS_SARCASM_ENABLED, SARCASM_THRESHOLD_PERCENTAGE } from '../../../common/globalConstants';
import { t } from 'i18next';
import {
  COMMON_I18N_PREFIX,
  COMMON_I18N_KEYS
} from './constants/i18n/Commoni18nConstants';

export class UploadedComment extends Component {
  static propTypes = {
    uploadedComment: PropTypes.object.isRequired,
    updateRelevance: PropTypes.func.isRequired,
    updateUploadedCommentsIsSarcasmManuallyToggled: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      uploadedComment: {
        comment: "",
        isTranslated:false,
        commentInOriginalLanguage : "",
        source: "",
        sentiment: {
          category: ""
        },
        emotion: {
          category: ""
        },
        sarcasm: {
          score: 0
        }
      },
      isSeeMore: false,
      isEllipsisActive: false
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    const uploadedComment = this.props.uploadedComment;
    this.setState({
        uploadedComment: uploadedComment
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this._updateUploadedCommentToStateIfNeeded(this.props);
  }

  _updateUploadedCommentToStateIfNeeded(nextProps) {
    if (
      JSON.stringify(nextProps.uploadedComment) !==
      JSON.stringify(this.state.uploadedComment)
    ) {
      this.setState({
        uploadedComment: nextProps.uploadedComment
      });
    }
  }
  
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  toggleSeeMore = isSeeMore => {
    ReactGA.event(
      {
        category : 'Uploaded Comments',
        action : `User with id ${this.props.cookies.userMeta} was redirected to see more about ${this.props.uploadedComment} from ${this.state.uploadedComment.source}`
      }
    )
    this.setState({isSeeMore});
  }

  getI18nText(textKey) {
    return t(COMMON_I18N_PREFIX + "." + textKey);
  }


  _returnEmotionPillClass = () => {
    const {uploadedComment} = this.state;
    const userEmotion = uploadedComment.emotion.category
    if (userEmotion === NO_SPECIFIC_EMOTION) {
      return NO_SPECIFIC_EMOTION_PILL_CLASS;
    } else {
      return userEmotion;
    }
  }

  _returnSarcasmPillClass = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {uploadedComment} = this.state;
    const isSarcasmManuallyToggled = uploadedComment.sarcasm.isSarcasmManuallyToggled;
    const sarcasmScorePercentageFormatRounded = this._returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces(uploadedComment.sarcasm.score);
    if (sarcasmScorePercentageFormatRounded >= SARCASM_THRESHOLD_PERCENTAGE) {
      if (!isSarcasmManuallyToggled) {
        return SARCASTIC_PILL_CLASS;
      }
      else {
        return NOT_SARCASTIC_PILL_CLASS;
      }
    }
    else if (sarcasmScorePercentageFormatRounded >= 0) {
      if (!isSarcasmManuallyToggled) {
        return NOT_SARCASTIC_PILL_CLASS;
      }
      else {
        return SARCASTIC_PILL_CLASS;
      }
    }
    return '';
  }
  
  _returnSarcasmPillText = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {uploadedComment} = this.state;
    const isSarcasmManuallyToggled = uploadedComment.sarcasm.isSarcasmManuallyToggled;
    const sarcasmScorePercentageFormatRounded = this._returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces(uploadedComment.sarcasm.score);
    if (sarcasmScorePercentageFormatRounded >= SARCASM_THRESHOLD_PERCENTAGE) {
      if (!isSarcasmManuallyToggled) {
        return `${SARCASTIC_LABEL} (${sarcasmScorePercentageFormatRounded}%)`;
      }
      else {
        return `${NOT_SARCASTIC_LABEL}`;
      }
      
    }
    else if (sarcasmScorePercentageFormatRounded >= 0) {
      if (!isSarcasmManuallyToggled) {
        return `${NOT_SARCASTIC_LABEL} (${sarcasmScorePercentageFormatRounded}%)`;
      }
      else {
        return `${SARCASTIC_LABEL}`;
      }
      
    }
    return '';
  }

  _returnSarcasmPillHoverText = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {uploadedComment} = this.state;
    if (uploadedComment.sarcasm.isSarcasmManuallyToggled) {
      return SARCASM_MANUALLY_TOGGLED_HOVER_TEXT;
    }
    else {
      const sarcasmScorePercentageFormatRounded = this._returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces(uploadedComment.sarcasm.score);
      return `${SARCASM_CONFIDENCE_SCORE_HOVER_TEXT} ${sarcasmScorePercentageFormatRounded}%`;
    }
  }

  _returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces = (sarcasmScore) => {
    const sarcasmScorePercentageFormat = sarcasmScore * 100;
    const sarcasmScorePercentageFormatRounded = +(Math.round(parseFloat(sarcasmScorePercentageFormat + E_PLUS_TWO)) + E_MINUS_TWO);
    return sarcasmScorePercentageFormatRounded;
  }

  _returnShouldSarcasmFeaturesBeShown = () => {
    const {uploadedComment} = this.state;
    return (IS_SARCASM_ENABLED && uploadedComment.sarcasm.score >= 0);
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isEllipsisActive: false });
    }
  }

  toggleIfEllipsisIsActive= () => {
    this.setState(prevState => {
      return { isEllipsisActive: !prevState.isEllipsisActive };
    });
  
  }

  updateRelevanceInDropdown = commentId => {
    const { updateRelevance } = this.props;
    updateRelevance(commentId);
    this.setState({
      isEllipsisActive: false
    });
  }

  updateIsSarcasmManuallyToggledInDropdown = commentId => {
    const { updateUploadedCommentsIsSarcasmManuallyToggled } = this.props;
    updateUploadedCommentsIsSarcasmManuallyToggled(commentId);
    this.setState({
      isEllipsisActive: false
    });
  }


  renderOriginalLanguageOfUploadedCommentIfItIsTranslated(uploadedComment,isSeeMore){
    return uploadedComment.isTranslated && (
      <div className='original-non-english'>
        <div className='vertical-line'/>
        <div className="content">
            <a href={uploadedComment.sourceLink} target="_blank">
              <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`} >
                {uploadedComment.commentInOriginalLanguage}
              </p>
            </a>
            {uploadedComment.commentInOriginalLanguage.length > MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB && !isSeeMore ? (
              <button className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                <u>{this.getI18nText(COMMON_I18N_KEYS.see_more)}</u>
              </button>
            ) : (
                uploadedComment.commentInOriginalLanguage.length > MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB &&
              isSeeMore && (
                <button className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                  {this.getI18nText(COMMON_I18N_KEYS.see_less)}
                </button>
              )
            )}
        </div>
    </div>
    )
  }

  render() {
    const { 
      uploadedComment,
      isSeeMore,
      isEllipsisActive
    } = this.state;
    const emotionPillClass = this._returnEmotionPillClass();
    const shouldSarcasmFeaturesBeShown = this._returnShouldSarcasmFeaturesBeShown();
    const sarcasmPillText  = this._returnSarcasmPillText();
    const sarcasmPillClass = this._returnSarcasmPillClass();
    const sarcasmPillHoverText = this._returnSarcasmPillHoverText();
    return (
        <div className="comment-card">
          <div className="header">
            <div 
              className="category"
              ref={this.wrapperRef}
            >
              <div className="card-header-button">
                {uploadedComment.sentiment.category && (
                  <button className={`btn-positive ${uploadedComment.sentiment.category}`}>
                    {uploadedComment.sentiment.category}
                  </button>
                )}
              </div>
                {uploadedComment.emotion.category && (
                    <div className="card-header-button">
                      {uploadedComment.emotion.category && (
                        <button className={`btn-emotion ${emotionPillClass}`}>
                          {uploadedComment.emotion.category}
                        </button>
                      )}
                    </div>
                  )}

                <div className="card-header-button">
                  {shouldSarcasmFeaturesBeShown &&
                    (
                      <button 
                        className={`btn-emotion ${sarcasmPillClass}`}
                        title={sarcasmPillHoverText}
                      >
                        {sarcasmPillText} 
                        {uploadedComment.sarcasm.isSarcasmManuallyToggled ? <i className="las la-user-edit icon"></i> : ''}
                      </button>
                  )}
                </div>
                <button 
                  className={`ellipsis ${isEllipsisActive ? 'active' : ''}`}
                  onClick={() => this.toggleIfEllipsisIsActive()} 
                >
                  <i className="la la-ellipsis-v"></i>
                </button>
                {isEllipsisActive && (
                  <div className="comments-toggle default-toggle-card-margin">
                    <RelevanceCard
                      userCommentOrPost={this.props.uploadedComment}
                      updateRelevance={e => this.updateRelevanceInDropdown(e)}
                      commentOrPostId={String(this.props.uploadedComment.commentId)}
                    />
                    {shouldSarcasmFeaturesBeShown && (
                      <SarcasmTogglingCard
                        userComment={this.props.uploadedComment}
                        updateIsSarcasmManuallyToggled={e => this.updateIsSarcasmManuallyToggledInDropdown(e)}
                        commentId={String(this.props.uploadedComment.commentId)}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          <div className="content uploaded-comment-container uploaded-comment-source">
            <p>{uploadedComment.source}</p>
          </div>
          <div className="content uploaded-comment-container">
            <a href={uploadedComment.sourceLink} target="_blank">
              <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`}>
                 {uploadedComment.comment}
              </p>
            </a>
            {uploadedComment.comment.length > MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB && !isSeeMore ? (
              <button className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                <u>{this.getI18nText(COMMON_I18N_KEYS.see_more)}</u>
              </button>
            ) : (
                uploadedComment.comment.length > MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB &&
              isSeeMore && (
                <button className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                  {this.getI18nText(COMMON_I18N_KEYS.see_less)}
                </button>
              )
            )}
          </div>
          {this.renderOriginalLanguageOfUploadedCommentIfItIsTranslated(uploadedComment,isSeeMore)}
          <div className={`card-header-bottom ${!uploadedComment.relevance ? 'card-header-bottom-space-between' : ''}`}>
              {!uploadedComment.relevance && (
                <div className="card-header-irrelevant">{MARKED_AS_IRRELEVANT_LABEL}</div>
              )}
              <label>{moment(uploadedComment.datetime).format(DATETIME_FORMAT_FOR_CARD_DISPLAY)}</label>
          </div>
        </div>
      )
  }
}

export default UploadedComment;



// WEBPACK FOOTER //
// ./src/features/home/components/UploadedComment.js